import { MediabankAsset } from '~/types/media'

import MediabankAssetComponent from './MediabankAsset/MediabankAsset'

export default function MediaMediabank({ assets }: { assets: MediabankAsset[] }): React.ReactElement {
  return (
    <div className="max-w-sm md:max-w-2xl xl:max-w-5xl mx-auto">
      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-8">
        {assets.map((elem) => (
          <MediabankAssetComponent key={elem._id} {...elem} slug={elem.slug.current} />
        ))}
      </div>
    </div>
  )
}
